// extracted by mini-css-extract-plugin
export default {"default":"Button_default__HRFrg","wide":"Button_wide__teuVg","outlined":"Button_outlined__u6jAU","contained":"Button_contained__pdbCW","disabled":"Button_disabled__EARfO"};